const FIRST_NAMES = ['Carlos', 'Aisha', 'Wei', 'Ibrahim', 'Maria', 'James', 'Fatima', 'Yuki', 'Ahmed', 'Sara', 'Michael', 'Priya', 'David', 'Chen', 'Olivia', 'Raj', 'Emma', 'Luis', 'Anna', 'Hassan', 'Sophie', 'Daniel', 'Leila', 'Tomás', 'Nadia'];
const LAST_NAMES = ['Martinez', 'Johnson', 'Zhang', 'Al-Farsi', 'Santos', 'Williams', 'Hassan', 'Tanaka', 'Khan', 'López', 'Brown', 'Patel', 'Kim', 'García', 'Wilson', 'Singh', 'Chen', 'Rivera', 'Adams', 'Nguyen', 'Müller', 'Park', 'Ali', 'Costa', 'Suzuki'];
const STREETS = ['Main St', 'Oak Ave', 'Elm Blvd', 'Pine Rd', 'Maple Dr', 'Cedar Ln', '5th Ave', 'Broadway', 'Park Ave', 'Market St'];
const CITIES = ['New York', 'Los Angeles', 'Chicago', 'Houston', 'Phoenix', 'Miami', 'Dallas', 'San Jose', 'Austin', 'Denver'];
const VEHICLES = ['Toyota Camry 2022', 'Honda Civic 2023', 'Tesla Model 3', 'Ford Explorer 2021', 'Hyundai Sonata 2023', 'Chevrolet Malibu 2022', 'Nissan Altima 2023', 'BMW 3 Series', 'Mercedes C-Class', 'Kia K5 2024'];

function rand(min: number, max: number) { return Math.floor(Math.random() * (max - min + 1)) + min; }
function pick<T>(arr: T[]): T { return arr[rand(0, arr.length - 1)]; }
function genPhone() { return `+1 (${rand(200, 999)}) ${rand(100, 999)}-${rand(1000, 9999)}`; }
function genEmail(first: string, last: string) { return `${first.toLowerCase()}.${last.toLowerCase()}@email.com`; }
function genPlate() { return `${String.fromCharCode(65 + rand(0, 25))}${String.fromCharCode(65 + rand(0, 25))}${String.fromCharCode(65 + rand(0, 25))}-${rand(1000, 9999)}`; }
function genAddress() { return `${rand(100, 9999)} ${pick(STREETS)}, ${pick(CITIES)}`; }
function genCountry() { return pick(['US', 'US', 'US', 'CA', 'GB', 'AE', 'SA', 'MX', 'BR', 'AU']); }
function daysAgo(n: number) { const d = new Date(); d.setDate(d.getDate() - n); return d.toISOString(); }
function genTxId() { return `TXN-${rand(100000, 999999)}`; }
function genCard() { return String(rand(1000, 9999)); }

const USER_STATUSES = ['ACTIVE', 'ACTIVE', 'ACTIVE', 'INACTIVE', 'PENDING'];
const DRIVER_STATUSES = ['ACTIVE_PAYING', 'ACTIVE_PAYING', 'ACTIVE_PAYING', 'GRACE_PERIOD', 'INACTIVE', 'SUSPENDED'];
const FEE_TYPES = ['DAILY', 'WEEKLY', 'BIWEEKLY', 'MONTHLY', 'COMMISSION'];
const TRIP_STATUSES = ['REQUESTED', 'CONFIRMED', 'ON_THE_WAY', 'ARRIVED', 'STARTED', 'COMPLETED', 'COMPLETED', 'COMPLETED', 'CANCELLED'];
const PAYMENT_STATUSES = ['PAID', 'PAID', 'PAID', 'PAID', 'PENDING', 'FAILED', 'REFUNDED'];
const PAYMENT_METHODS = ['STRIPE', 'STRIPE', 'STRIPE', 'APPLE_PAY', 'GOOGLE_PAY', 'ZELLE', 'CASH'];

const GEO_COMBOS: { country: string; state: string; city: string }[] = [
  { country: 'US', state: 'NY',  city: 'New York' },
  { country: 'US', state: 'CA',  city: 'Los Angeles' },
  { country: 'US', state: 'TX',  city: 'Houston' },
  { country: 'US', state: 'FL',  city: 'Miami' },
  { country: 'US', state: 'IL',  city: 'Chicago' },
  { country: 'CA', state: 'ON',  city: 'Toronto' },
  { country: 'GB', state: 'ENG', city: 'London' },
  { country: 'AE', state: 'DXB', city: 'Dubai' },
  { country: 'FR', state: 'IDF', city: 'Paris' },
  { country: 'SA', state: 'RIY', city: 'Riyadh City' },
];

function generateUsers(count: number) {
  return Array.from({ length: count }, (_, i) => {
    const firstName = pick(FIRST_NAMES);
    const lastName = pick(LAST_NAMES);
    const geo = pick(GEO_COMBOS);
    return {
      id: i + 1,
      firstName,
      lastName,
      email: genEmail(firstName, lastName),
      phone: genPhone(),
      status: pick(USER_STATUSES),
      rating: +(rand(30, 50) / 10).toFixed(1),
      totalTrips: rand(0, 250),
      totalPaid: +(rand(500, 25000) / 100).toFixed(2),
      totalTips: +(rand(50, 5000) / 100).toFixed(2),
      countryCode: geo.country,
      address: {
        country: geo.country,
        state: geo.state,
        city: geo.city,
      },
      createdAt: daysAgo(rand(1, 365)),
      avatar: null,
    };
  });
}

function generateDrivers(count: number) {
  return Array.from({ length: count }, (_, i) => {
    const first = pick(FIRST_NAMES);
    const last = pick(LAST_NAMES);
    const status = pick(DRIVER_STATUSES);
    const geo = pick(GEO_COMBOS);
    return {
      id: i + 1,
      name: `${first} ${last}`,
      firstName: first,
      lastName: last,
      email: genEmail(first, last),
      phone: genPhone(),
      feeType: pick(FEE_TYPES),
      status,
      rating: +(rand(35, 50) / 10).toFixed(1),
      totalTrips: rand(10, 500),
      earnings: rand(500, 15000),
      vehicle: pick(VEHICLES),
      licensePlate: genPlate(),
      licenseId: `DL-${rand(100000, 999999)}`,
      carBrand: pick(['Toyota', 'Honda', 'Tesla', 'Ford', 'Hyundai', 'Chevrolet', 'Nissan', 'BMW', 'Mercedes', 'Kia']),
      carYear: String(rand(2019, 2025)),
      vehicleColor: pick(['White', 'Black', 'Silver', 'Blue', 'Red', 'Gray', 'Green']),
      serviceType: pick(['AXS', 'AXS', 'AXM', 'AXL', 'AXB', 'AXR', 'AXE', 'AXWAV', 'AXPOOL']),
      handicapped: rand(0, 10) > 8,
      dob: daysAgo(rand(8000, 18000)),
      taxNumber: `***-**-${rand(1000, 9999)}`,
      licenseExpiry: daysAgo(rand(-365, -30)),
      countryCode: geo.country,
      address: {
        street: `${rand(100, 9999)} ${pick(STREETS)}`,
        country: geo.country, state: geo.state, city: geo.city,
        zip: String(rand(10000, 99999)),
      },
      graceDaysLeft: status === 'GRACE_PERIOD' ? rand(1, 30) : undefined,
      createdAt: daysAgo(rand(1, 365)),
      avatar: null,
      profilePhoto: null,
      carPhoto: null,
    };
  });
}

function generatePendingDrivers(count: number) {
  return Array.from({ length: count }, (_, i) => {
    const first = pick(FIRST_NAMES);
    const last = pick(LAST_NAMES);
    return {
      id: 1000 + i + 1,
      name: `${first} ${last}`,
      firstName: first,
      lastName: last,
      email: genEmail(first, last),
      phone: genPhone(),
      vehicle: pick(VEHICLES),
      licensePlate: genPlate(),
      createdAt: daysAgo(rand(1, 14)),
    };
  });
}

const AIRPORTS = ['LAX', 'JFK', 'ORD', 'MIA', 'SFO', 'DFW', 'ATL', 'DEN', 'SEA', 'BOS'];
const TERMINALS = ['Terminal 1', 'Terminal 2', 'Terminal 3', 'Terminal 4', 'International'];
const WAITING_ZONES = ['Zone A', 'Zone B', 'Zone C', 'Rideshare Lot', 'Cell Phone Lot'];

function buildTrip(id: number, user: any, driver: any) {
  const tripGeo = pick(GEO_COMBOS);
  const baseFare = +(rand(800, 5000) / 100).toFixed(2);
  const surgeFeeVal = +(rand(100, 600) / 100).toFixed(2);
  const airportFeeVal = +(rand(200, 800) / 100).toFixed(2);
  const miscFeeVal = +(rand(50, 500) / 100).toFixed(2);
  const cityFeeVal = +(rand(100, 400) / 100).toFixed(2);
  const tipVal = +(rand(100, 800) / 100).toFixed(2);
  const bonus = rand(0, 10) > 7 ? +(rand(100, 500) / 100).toFixed(2) : 0;
  const waitingFee = rand(0, 10) > 6 ? +(rand(50, 300) / 100).toFixed(2) : 0;
  const additionalCharges = rand(0, 10) > 8 ? +(rand(100, 800) / 100).toFixed(2) : 0;
  const fareSubtotal = +(baseFare + surgeFeeVal + airportFeeVal + miscFeeVal + cityFeeVal + bonus + waitingFee + additionalCharges).toFixed(2);
  const totalFare = +(fareSubtotal + tipVal).toFixed(2);
  const estimatedDistance = (rand(10, 250) / 10);
  const actualDistance = +(estimatedDistance + (rand(-20, 30) / 10)).toFixed(1);
  const estimatedMinutes = rand(5, 75);
  const actualMinutes = estimatedMinutes + rand(-5, 15);
  const extraMiles = +(actualDistance - estimatedDistance).toFixed(1);
  const extraMinutes = actualMinutes - estimatedMinutes;
  const isAirport = rand(0, 10) > 4;
  const isSubscription = driver.feeType !== 'COMMISSION';
  const commissionRate = isSubscription ? 0 : pick([0.18, 0.20, 0.22, 0.25]);
  const commissionBase = +(baseFare + surgeFeeVal).toFixed(2);
  const commission = isSubscription ? 0 : +(commissionBase * commissionRate).toFixed(2);
  const estimatedBaseFare = +(baseFare + (rand(-200, 100) / 100)).toFixed(2);
  const estimatedSurgeFee = +(surgeFeeVal * (0.8 + rand(0, 4) / 10)).toFixed(2);
  const estimatedAirportFee = airportFeeVal;
  const estimatedMiscFee = miscFeeVal;
  const estimatedCityFee = cityFeeVal;
  const estimatedFare = +(estimatedBaseFare + estimatedSurgeFee + estimatedAirportFee + estimatedMiscFee + estimatedCityFee).toFixed(2);
  return {
    id,
    transactionId: `TXN-${rand(100000, 999999)}`,
    passengerId: user.id,
    passengerName: `${user.firstName} ${user.lastName}`,
    driverId: driver.id,
    driverName: driver.name,
    pickup: genAddress(),
    dropoff: genAddress(),
    pickupTime: daysAgo(rand(0, 90)),
    dropoffTime: daysAgo(rand(0, 89)),
    country: tripGeo.country,
    city: tripGeo.city,
    status: pick(TRIP_STATUSES),
    estimatedFare,
    estimatedBaseFare,
    estimatedAirportFee,
    estimatedMiscFee,
    estimatedCityFee,
    estimatedSurgeFee,
    estimatedDistance: `${estimatedDistance.toFixed(1)} mi`,
    estimatedDuration: `${estimatedMinutes} min`,
    baseFare,
    bonus: bonus || null,
    waitingFee: waitingFee || null,
    waitingMinutes: waitingFee ? rand(3, 20) : 0,
    additionalCharges: additionalCharges || null,
    fare: fareSubtotal,
    tip: tipVal,
    airportFee: airportFeeVal,
    miscFee: miscFeeVal,
    cityEntryFee: cityFeeVal,
    surgeFee: surgeFeeVal,
    total: totalFare,
    commission,
    commissionRate,
    subscription: isSubscription ? 'Active' : null,
    subscriptionDiscount: 0,
    extraMiles: extraMiles > 0 ? extraMiles : null,
    extraMinutes: extraMinutes > 0 ? extraMinutes : null,
    airport: isAirport ? pick(AIRPORTS) : null,
    terminal: isAirport ? pick(TERMINALS) : null,
    waitingZone: isAirport ? pick(WAITING_ZONES) : null,
    flightNumber: isAirport ? `${pick(['AA','UA','DL','SW','JB'])}${rand(100,9999)}` : null,
    distance: `${Math.max(actualDistance, 0.5).toFixed(1)} mi`,
    duration: `${Math.max(actualMinutes, 3)} min`,
    rating: rand(0, 10) > 3 ? +(rand(30, 50) / 10).toFixed(1) : null,
    createdAt: daysAgo(rand(0, 90)),
  };
}

function generateTripsPerDriver(users: any[], drivers: any[]) {
  const allTrips: any[] = [];
  let tripId = 10001;
  for (const driver of drivers) {
    const tripCount = rand(8, 22);
    for (let j = 0; j < tripCount; j++) {
      allTrips.push(buildTrip(tripId++, pick(users), driver));
    }
  }
  return allTrips;
}

function generatePaymentsFromTrips(allTrips: any[]) {
  return allTrips
    .map((t, i) => {
      const paymentId = i + 1;
      t.paymentId = paymentId;
      const method = pick(PAYMENT_METHODS);
      const commissionRate = t.commissionRate ?? pick([0.18, 0.20, 0.22, 0.25]);
      const isSub = !!t.subscription;

      const baseFare = t.baseFare || +(rand(400, 6000) / 100).toFixed(2);
      const airportFee = t.airportFee || 0;
      const miscFee = t.miscFee || 0;
      const cityEntryFee = t.cityEntryFee || 0;
      const surgeFee = t.surgeFee || 0;
      const tip = t.tip || 0;

      const totalFees = +(airportFee + miscFee + cityEntryFee).toFixed(2);
      const riderTotal = +(baseFare + surgeFee + totalFees + tip).toFixed(2);
      const commissionBase = +(baseFare + surgeFee).toFixed(2);
      const commission = isSub ? 0 : +(commissionBase * commissionRate).toFixed(2);
      const driverNet = +(riderTotal - commission - totalFees).toFixed(2);
      const processingFee = +(riderTotal * 0.029 + 0.30).toFixed(2);

      const estBaseFare = t.estimatedBaseFare || +(baseFare + (rand(-200, 100) / 100)).toFixed(2);
      const estAirportFee = t.estimatedAirportFee || airportFee;
      const estCityFee = t.estimatedCityFee || cityEntryFee;
      const estMiscFee = t.estimatedMiscFee || miscFee;
      const estSurgeFee = t.estimatedSurgeFee || 0;
      const estTotalFees = +((estAirportFee || 0) + estMiscFee + estCityFee).toFixed(2);
      const estTotal = +(estBaseFare + estSurgeFee + estTotalFees).toFixed(2);
      const estCommBase = +(estBaseFare + estSurgeFee).toFixed(2);
      const estCommission = isSub ? 0 : +(estCommBase * commissionRate).toFixed(2);

      return {
        id: i + 1,
        transactionId: t.transactionId || genTxId(),
        tripId: t.id,
        passengerId: t.passengerId,
        passengerName: t.passengerName,
        driverId: t.driverId,
        driverName: t.driverName,
        country: t.country || 'US',
        estimatedBaseFare: estBaseFare,
        estimatedDistance: t.estimatedDistance,
        estimatedDuration: t.estimatedDuration,
        estimatedAirportFee: estAirportFee,
        estimatedCityFee: estCityFee,
        estimatedMiscFee: estMiscFee,
        estimatedSurgeFee: estSurgeFee,
        estimatedCommission: estCommission,
        estimatedTotalFees: estTotalFees,
        estimatedTotal: estTotal,
        estimatedDriverNet: +(estTotal - estCommission - estTotalFees).toFixed(2),
        actualDistance: t.distance,
        actualDuration: t.duration,
        baseFare,
        fare: baseFare,
        tip,
        airportFee: airportFee || null,
        miscFee: miscFee || null,
        cityEntryFee: cityEntryFee || null,
        surgeFee: surgeFee || null,
        waitingFee: t.waitingFee || null,
        waitingMinutes: t.waitingMinutes || 0,
        subscription: t.subscription,
        subscriptionDiscount: t.subscriptionDiscount || 0,
        amount: riderTotal,
        totalFees,
        commission,
        commissionRate,
        driverNet,
        processingFee,
        netProfit: commission,
        method,
        cardLast4: method === 'STRIPE' ? genCard() : null,
        cardBrand: method === 'STRIPE' ? pick(['Visa', 'Mastercard', 'Amex']) : null,
        status: pick(PAYMENT_STATUSES),
        createdAt: t.createdAt,
      };
    });
}

const BOOKING_STATUSES = ['REQUESTED', 'CONFIRMED', 'ON_THE_WAY', 'ARRIVED', 'STARTED', 'COMPLETED', 'COMPLETED', 'CANCELLED'];
const DOC_TYPES = ['LICENSE', 'TLC', 'INSURANCE', 'REGISTRATION'];
const DOC_STATUSES = ['PENDING', 'APPROVED', 'APPROVED', 'APPROVED', 'REJECTED'];
const REVIEW_STATUSES = ['PUBLISHED', 'PUBLISHED', 'PUBLISHED', 'UNPUBLISHED'];
const PROMO_STATUSES = ['ACTIVE', 'ACTIVE', 'EXPIRED', 'DRAFT'];
const SERVICE_TYPES = ['GENERAL', 'GENERAL', 'MOVING'];
const PAY_TYPES = ['PAYPAL', 'CREDIT_CARD', 'CREDIT_CARD', 'CASH'];
const COUNTRIES = [
  { id: 1, sortName: 'US', name: 'United States', phoneCode: '+1' },
  { id: 2, sortName: 'MX', name: 'Mexico', phoneCode: '+52' },
  { id: 3, sortName: 'CA', name: 'Canada', phoneCode: '+1' },
  { id: 4, sortName: 'GB', name: 'United Kingdom', phoneCode: '+44' },
  { id: 5, sortName: 'AE', name: 'United Arab Emirates', phoneCode: '+971' },
  { id: 6, sortName: 'SA', name: 'Saudi Arabia', phoneCode: '+966' },
  { id: 7, sortName: 'DE', name: 'Germany', phoneCode: '+49' },
  { id: 8, sortName: 'FR', name: 'France', phoneCode: '+33' },
  { id: 9, sortName: 'JP', name: 'Japan', phoneCode: '+81' },
  { id: 10, sortName: 'BR', name: 'Brazil', phoneCode: '+55' },
];
const STATES_DATA = [
  { countryId: 1, countryName: 'United States', names: ['California', 'New York', 'Texas', 'Florida', 'Illinois', 'Arizona', 'Colorado'] },
  { countryId: 2, countryName: 'Mexico', names: ['Jalisco', 'Mexico City', 'Nuevo León'] },
  { countryId: 3, countryName: 'Canada', names: ['Ontario', 'Quebec', 'British Columbia'] },
  { countryId: 4, countryName: 'United Kingdom', names: ['England', 'Scotland', 'Wales'] },
];
const CITIES_BY_STATE: Record<string, string[]> = {
  'California': ['Los Angeles', 'San Francisco', 'San Diego', 'San Jose'],
  'New York': ['New York City', 'Buffalo', 'Albany'],
  'Texas': ['Houston', 'Dallas', 'Austin', 'San Antonio'],
  'Florida': ['Miami', 'Orlando', 'Tampa'],
  'Illinois': ['Chicago', 'Springfield'],
  'Ontario': ['Toronto', 'Ottawa'],
  'Quebec': ['Montreal', 'Quebec City'],
  'England': ['London', 'Manchester', 'Birmingham'],
};
const CATEGORY_NAMES = ['Economy', 'Comfort', 'Luxury', 'M-bike', 'Rickshaw', 'Electric', 'Wheelchair Accessible', 'Pool'];
const LOCATION_NAMES = ['Airport Terminal 1', 'Airport Terminal 2', 'Downtown Hub', 'Central Station', 'Mall Entrance', 'Hospital Main', 'University Gate', 'Convention Center', 'Beach Parking', 'Hotel District'];
const EMPLOYER_NAMES = ['TechCorp Inc.', 'GlobalFinance LLC', 'HealthFirst Medical', 'EduPrime Academy', 'GreenLogistics Co.', 'MetroTransit Authority', 'SkyHigh Airlines', 'Pinnacle Hotels', 'BlueStar Manufacturing'];
const PROMO_CODES = [
  'WELCOME20', 'SUMMER15', 'RIDE10', 'FIRST50', 'HOLIDAY25', 'VIP30', 'FLASH5', 'REFER20', 'WEEKEND10', 'NEWUSER',
  'EARLYBIRD', 'LOYALTY10', 'SAVE25', 'GORIDE', 'TRYNEW', 'CARPOOL5', 'NIGHTOWL', 'DAYDEAL', 'RUSH15', 'METRO20',
  'AIRPORT10', 'PREMIUM30', 'ECO5', 'FAMILY20', 'COMMUTE10', 'LAUNCH50', 'SPRING20', 'AUTUMN15', 'WINTER10', 'FESTIVE25',
  'EXPRESS30', 'BONUS15', 'RETURN20', 'WEEKLY5', 'MONTHLY10', 'STUDENT15', 'SENIOR10', 'WORK20', 'CORP25', 'EVENT30',
];

function generateBookings(count: number, users: any[], drivers: any[], allTrips?: any[]) {
  return Array.from({ length: count }, (_, i) => {
    const status = pick(BOOKING_STATUSES);
    let user: any, driver: any, tripId: number | null = null;
    if (status === 'COMPLETED' && allTrips?.length) {
      const trip = pick(allTrips);
      tripId = trip.id;
      user = users.find((u: any) => u.id === trip.passengerId) || pick(users);
      driver = drivers.find((d: any) => d.id === trip.driverId) || pick(drivers);
    } else {
      user = pick(users);
      driver = pick(drivers);
    }
    const baseFare = +(rand(400, 6000) / 100).toFixed(2);
    const bonus = rand(0, 10) > 7 ? +(rand(100, 500) / 100).toFixed(2) : 0;
    const waitingFee = rand(0, 10) > 6 ? +(rand(50, 300) / 100).toFixed(2) : 0;
    const waitingMinutes = waitingFee ? rand(3, 20) : 0;
    const additionalCharges = rand(0, 10) > 8 ? +(rand(100, 800) / 100).toFixed(2) : 0;
    const tipVal = rand(0, 10) > 7 ? +(rand(100, 500) / 100).toFixed(2) : 0;
    const airportFee = +(rand(200, 800) / 100).toFixed(2);
    const miscFee = +(rand(50, 500) / 100).toFixed(2);
    const cityEntryFee = +(rand(100, 400) / 100).toFixed(2);
    const surgeFee = rand(0, 10) > 5 ? +(rand(100, 600) / 100).toFixed(2) : 0;
    const cancellationFee = status === 'CANCELLED' ? +(rand(300, 1000) / 100).toFixed(2) : 0;
    const isSubscription = driver.feeType !== 'COMMISSION';
    const commissionRate = isSubscription ? 0 : pick([0.18, 0.20, 0.22, 0.25]);
    const estimatedDistance = (rand(10, 250) / 10);
    const actualDistance = +(estimatedDistance + (rand(-20, 30) / 10)).toFixed(1);
    const estimatedMinutes = rand(5, 75);
    const actualMinutes = estimatedMinutes + rand(-5, 15);
    const totalFare = status === 'CANCELLED'
      ? +(baseFare + cancellationFee).toFixed(2)
      : +(baseFare + bonus + waitingFee + additionalCharges + tipVal + airportFee + miscFee + cityEntryFee + surgeFee).toFixed(2);
    const commissionBase = +(baseFare + surgeFee).toFixed(2);
    const commission = isSubscription ? 0 : +(commissionBase * commissionRate).toFixed(2);
    const estimatedBaseFare = +(baseFare + (rand(-200, 100) / 100)).toFixed(2);
    const estimatedFare = +(estimatedBaseFare + airportFee + miscFee + cityEntryFee + (surgeFee > 0 ? +(surgeFee * 0.8).toFixed(2) : 0)).toFixed(2);
    return {
      id: 20000 + i + 1,
      transactionId: `TXN-${rand(100000, 999999)}`,
      tripId,
      passengerId: user.id,
      passengerName: `${user.firstName} ${user.lastName}`,
      driverId: driver.id,
      driverName: driver.name,
      pickup: genAddress(),
      dropoff: genAddress(),
      scheduledAt: daysAgo(rand(-7, 30)),
      status,
      estimatedFare,
      estimatedBaseFare,
      estimatedAirportFee: airportFee,
      estimatedMiscFee: miscFee,
      estimatedCityFee: cityEntryFee,
      estimatedSurgeFee: surgeFee > 0 ? +(surgeFee * 0.8).toFixed(2) : 0,
      estimatedDistance: `${estimatedDistance.toFixed(1)} mi`,
      estimatedDuration: `${estimatedMinutes} min`,
      distance: `${Math.max(actualDistance, 0.5).toFixed(1)} mi`,
      duration: `${Math.max(actualMinutes, 3)} min`,
      baseFare,
      bonus: bonus || null,
      waitingFee: waitingFee || null,
      waitingMinutes,
      additionalCharges: additionalCharges || null,
      tip: tipVal || null,
      airportFee,
      miscFee,
      cityEntryFee,
      surgeFee: surgeFee || null,
      cancellationFee: cancellationFee || null,
      fare: totalFare,
      total: totalFare,
      commission,
      commissionRate,
      subscription: isSubscription ? 'Active' : null,
      subscriptionDiscount: 0,
      country: genCountry(),
    };
  });
}

function generateServiceRequests(count: number) {
  return Array.from({ length: count }, (_, i) => {
    const first = pick(FIRST_NAMES);
    const last = pick(LAST_NAMES);
    return {
      id: i + 1,
      name: `${first} ${last}`,
      phone: genPhone(),
      email: genEmail(first, last),
      type: pick(SERVICE_TYPES),
      paymentType: pick(PAY_TYPES),
      amount: +(rand(2000, 50000) / 100).toFixed(2),
      pickupLocation: genAddress(),
      dropLocation: genAddress(),
      country: genCountry(),
      createdAt: daysAgo(rand(0, 60)),
    };
  });
}

function generateRatings(count: number, users: any[], drivers: any[], allTrips: any[]) {
  const reviewTexts = ['Great driver, very professional!', 'On time, clean car.', 'Could improve navigation.', 'Excellent service, will ride again.', 'Average experience.', 'Very friendly and helpful.', 'Took a longer route than needed.', 'Perfect ride, 5 stars!'];
  const ratingEntries = Array.from({ length: count }, (_, i) => {
    const trip = pick(allTrips);
    const user = users.find((u: any) => u.id === trip.passengerId) || pick(users);
    const driver = drivers.find((d: any) => d.id === trip.driverId) || pick(drivers);
    const direction = pick(['passenger_to_driver', 'passenger_to_driver', 'driver_to_passenger']);
    const passengerName = `${user.firstName} ${user.lastName}`;
    return {
      id: i + 1,
      type: 'rating' as const,
      tripId: trip.id,
      driverId: driver.id,
      driverName: driver.name,
      passengerId: user.id,
      passengerName,
      direction,
      raterName: direction === 'passenger_to_driver' ? passengerName : driver.name,
      raterId: direction === 'passenger_to_driver' ? user.id : driver.id,
      rateeName: direction === 'passenger_to_driver' ? driver.name : passengerName,
      rateeId: direction === 'passenger_to_driver' ? driver.id : user.id,
      rating: rand(1, 5),
      comment: rand(0, 3) > 1 ? pick(['Great ride!', 'On time.', 'Very professional.', 'Good experience.', '']) : null,
      status: 'PUBLISHED',
      country: trip.country || genCountry(),
      createdAt: trip.createdAt || daysAgo(rand(0, 90)),
    };
  });
  const reviewCount = Math.floor(count * 0.6);
  const reviewEntries = Array.from({ length: reviewCount }, (_, i) => {
    const trip = pick(allTrips);
    const user = users.find((u: any) => u.id === trip.passengerId) || pick(users);
    const driver = drivers.find((d: any) => d.id === trip.driverId) || pick(drivers);
    const passengerName = `${user.firstName} ${user.lastName}`;
    return {
      id: count + i + 1,
      type: 'review' as const,
      tripId: trip.id,
      driverId: driver.id,
      driverName: driver.name,
      passengerId: user.id,
      passengerName,
      direction: 'passenger_to_driver' as const,
      raterName: passengerName,
      raterId: user.id,
      rateeName: driver.name,
      rateeId: driver.id,
      rating: rand(1, 5),
      comment: pick(reviewTexts),
      status: pick(REVIEW_STATUSES),
      country: trip.country || genCountry(),
      createdAt: trip.createdAt || daysAgo(rand(0, 90)),
    };
  });
  return [...ratingEntries, ...reviewEntries];
}

function generateReviews(count: number, users: any[], drivers: any[], allTrips: any[]) {
  const reviewTexts = ['Great driver, very professional!', 'On time, clean car.', 'Could improve navigation.', 'Excellent service, will ride again.', 'Average experience.', 'Very friendly and helpful.', 'Took a longer route than needed.', 'Perfect ride, 5 stars!'];
  return Array.from({ length: count }, (_, i) => {
    const trip = pick(allTrips);
    const user = users.find((u: any) => u.id === trip.passengerId) || pick(users);
    const driver = drivers.find((d: any) => d.id === trip.driverId) || pick(drivers);
    return {
      id: i + 1,
      tripId: trip.id,
      driverId: driver.id,
      driverName: driver.name,
      passengerId: user.id,
      passengerName: `${user.firstName} ${user.lastName}`,
      review: pick(reviewTexts),
      status: pick(REVIEW_STATUSES),
      country: trip.country || genCountry(),
      createdAt: trip.createdAt || daysAgo(rand(0, 90)),
    };
  });
}

function generateDocuments(count: number, drivers: any[]) {
  const fileNames = ['drivers_license_front.jpg', 'drivers_license_back.jpg', 'tlc_license.pdf', 'insurance_card.pdf', 'vehicle_registration.pdf'];
  return Array.from({ length: count }, (_, i) => {
    const driver = pick(drivers);
    return {
      id: i + 1,
      driverId: driver.id,
      driverName: driver.name,
      country: pick(['US', 'CA', 'GB', 'AU', 'AE']),
      docType: pick([...DOC_TYPES, 'MISCELLANEOUS']),
      fileName: pick(fileNames),
      status: pick(DOC_STATUSES),
      expiresAt: daysAgo(rand(-365, -30)),
      uploadedAt: daysAgo(rand(0, 60)),
    };
  });
}

function generateDriverPaymentsFromTrips(allTrips: any[], drivers: any[]) {
  const driverMap = new Map(drivers.map(d => [d.id, d]));
  return allTrips.map((t, i) => {
    const driver = driverMap.get(t.driverId)!;
    const method = pick(PAYMENT_METHODS);
    const amount = t.total || t.fare;
    const commissionRate = t.commissionRate || pick([0.18, 0.20, 0.22, 0.25]);
    const commBase = +((t.baseFare || 0) + (t.surgeFee || 0)).toFixed(2);
    const commission = +(commBase * commissionRate).toFixed(2);
    const driverNet = +(+amount.toFixed(2) - commission).toFixed(2);
    return {
      id: i + 1,
      transactionId: t.transactionId || genTxId(),
      tripId: t.id,
      driverId: driver.id,
      driverName: driver.name,
      driverEmail: driver.email,
      estimatedFare: t.estimatedFare,
      fare: t.fare,
      tip: t.tip || 0,
      airportFee: t.airportFee || null,
      waitingFee: t.waitingFee || null,
      amount: +amount.toFixed(2),
      requestAmount: +driverNet.toFixed(2),
      tipAmount: +(t.tip || 0),
      balanceAmount: +driverNet.toFixed(2),
      commission,
      commissionRate,
      method,
      cardLast4: method === 'STRIPE' ? genCard() : null,
      status: pick(['PAID', 'PAID', 'PAID', 'PAID', 'PENDING']),
      country: t.country || genCountry(),
      requestDate: t.createdAt,
      createdAt: t.createdAt,
    };
  });
}

function generateCategories() {
  const seatMap: Record<string, number> = { Economy: 4, Comfort: 4, Luxury: 4, 'M-bike': 1, Rickshaw: 3, Electric: 4, 'Wheelchair Accessible': 4, Pool: 4 };
  const codeMap: Record<string, string> = { Economy: 'AXS', Comfort: 'AXM', Luxury: 'AXL', 'M-bike': 'AXB', Rickshaw: 'AXR', Electric: 'AXE', 'Wheelchair Accessible': 'AXWAV', Pool: 'AXPOOL' };
  const tierMap: Record<string, string> = { Economy: 'Economy', Comfort: 'Comfort', Pool: 'Economy', Luxury: 'Premium', 'M-bike': 'More', Rickshaw: 'More', Electric: 'More', 'Wheelchair Accessible': 'Accessibility' };
  const descMap: Record<string, string> = { AXS: 'Economy rides for everyday trips', AXM: 'Comfort rides with more space', AXL: 'Luxury rides with premium vehicles', AXB: 'M-bike rides for quick solo trips', AXR: 'Rickshaw rides for compact city trips', AXE: 'Eco-friendly electric vehicles', AXWAV: 'Wheelchair accessible vehicles', AXPOOL: 'Shared rides, lower cost', AXP: 'Shorter wait time' };
  return CATEGORY_NAMES.map((name, i) => {
    const serviceCode = codeMap[name] ?? 'AXS';
    return {
      id: i + 1,
      name,
      serviceCode,
      tier: tierMap[name] ?? 'Economy',
      description: descMap[serviceCode] ?? `${serviceCode} — ${name}`,
      status: i < 6 ? 'ACTIVE' : 'INACTIVE',
    allowSwitch: i % 2 === 0,
    numberOfSeats: seatMap[name] ?? 4,
    baseFare: +(rand(300, 800) / 100).toFixed(2),
    minimumFare: +(rand(500, 1200) / 100).toFixed(2),
    perMile: +(rand(100, 350) / 100).toFixed(2),
    perMinute: +(rand(15, 50) / 100).toFixed(2),
    estimatedEta: `${rand(3, 20)} min`,
    cancellationFee: +(rand(300, 1000) / 100).toFixed(2),
    rentalPrice: +(rand(5000, 15000) / 100).toFixed(2),
    speed: +(rand(8, 12) / 10).toFixed(1),
    handicapped: i === 3 || i === 6,
    country: genCountry(),
    createdAt: daysAgo(rand(30, 365)),
  };});
}

function generateLocations(cities: any[]) {
  return LOCATION_NAMES.map((name, i) => {
    const city = cities[i % cities.length];
    return {
      id: i + 1,
      name,
      address: genAddress(),
      latitude: (rand(2500, 4800) / 100).toFixed(4),
      longitude: (-rand(7000, 12200) / 100).toFixed(4),
      country: city.countryName,
      countryName: city.countryName,
      stateName: city.stateName,
      cityId: city.id,
      cityName: city.name,
      status: i < 8 ? 'ACTIVE' : 'INACTIVE',
    };
  });
}

function generateGeoCountries() {
  return COUNTRIES.map(c => ({ ...c, status: 'ACTIVE' }));
}

function generateGeoStates() {
  let id = 1;
  const states: any[] = [];
  STATES_DATA.forEach(s => {
    s.names.forEach(name => {
      states.push({ id: id++, name, countryId: s.countryId, countryName: s.countryName, status: 'ACTIVE' });
    });
  });
  return states;
}

function generateGeoCities(states: any[]) {
  let id = 1;
  const cities: any[] = [];
  states.forEach(s => {
    const cityNames = CITIES_BY_STATE[s.name] || [`${s.name} City`];
    cityNames.forEach(name => {
      cities.push({ id: id++, name, stateId: s.id, stateName: s.name, countryName: s.countryName, status: 'ACTIVE' });
    });
  });
  return cities;
}

const PROMO_GEO_POOL: { country: string; state: string; city: string }[] = [
  { country: 'US', state: 'NY',  city: 'New York City' },
  { country: 'US', state: 'NY',  city: 'Buffalo' },
  { country: 'US', state: 'CA',  city: 'Los Angeles' },
  { country: 'US', state: 'CA',  city: 'San Francisco' },
  { country: 'US', state: 'TX',  city: 'Houston' },
  { country: 'US', state: 'TX',  city: 'Dallas' },
  { country: 'US', state: 'FL',  city: 'Miami' },
  { country: 'US', state: 'FL',  city: 'Orlando' },
  { country: 'US', state: 'IL',  city: 'Chicago' },
  { country: 'CA', state: 'ON',  city: 'Toronto' },
  { country: 'CA', state: 'ON',  city: 'Ottawa' },
  { country: 'CA', state: 'BC',  city: 'Vancouver' },
  { country: 'CA', state: 'QC',  city: 'Montreal' },
  { country: 'GB', state: 'ENG', city: 'London' },
  { country: 'GB', state: 'ENG', city: 'Manchester' },
  { country: 'GB', state: 'SCO', city: 'Edinburgh' },
  { country: 'AE', state: 'DXB', city: 'Dubai City' },
  { country: 'AE', state: 'AUH', city: 'Abu Dhabi City' },
  { country: 'SA', state: 'RIY', city: 'Riyadh City' },
  { country: 'SA', state: 'MKH', city: 'Jeddah' },
  { country: 'MX', state: 'CMX', city: 'Mexico City' },
  { country: 'MX', state: 'JAL', city: 'Guadalajara' },
  { country: 'BR', state: 'SP',  city: 'São Paulo' },
  { country: 'BR', state: 'RJ',  city: 'Rio de Janeiro' },
  { country: 'AU', state: 'NSW', city: 'Sydney' },
  { country: 'AU', state: 'VIC', city: 'Melbourne' },
  { country: 'DE', state: 'BY',  city: 'Munich' },
  { country: 'DE', state: 'BE',  city: 'Berlin' },
  { country: 'FR', state: 'IDF', city: 'Paris' },
  { country: 'IN', state: 'MH',  city: 'Mumbai' },
];

function generatePromos() {
  const promos: any[] = [];
  let id = 1;
  for (const geo of PROMO_GEO_POOL) {
    const count = rand(2, 4);
    for (let j = 0; j < count; j++) {
      const code = pick(PROMO_CODES) + (id > PROMO_CODES.length ? `-${rand(1, 99)}` : '');
      promos.push({
        id: id++,
        code,
        type: id % 3 === 0 ? 'FIXED' : 'PERCENTAGE',
        value: id % 3 === 0 ? `$${rand(5, 50)}` : `${rand(5, 50)}%`,
        userAllowed: rand(100, 1000),
        targetAudience: pick(['PASSENGERS', 'PASSENGERS', 'DRIVERS', 'ALL', 'ALL']),
        status: pick(PROMO_STATUSES),
        country: geo.country,
        state: geo.state,
        city: geo.city,
        expiresAt: daysAgo(rand(-90, 30)),
        createdAt: daysAgo(rand(30, 180)),
      });
    }
  }
  return promos;
}

function generateEmployers() {
  const designations = ['CEO', 'CTO', 'HR Manager', 'Fleet Manager', 'Operations Director', 'VP Transport', 'Logistics Lead', 'Regional Manager', 'Account Manager'];
  const roles = ['ADMIN', 'MANAGER', 'SUPPORT', 'VIEWER', 'ADMIN', 'MANAGER', 'SUPPORT', 'VIEWER', 'ADMIN'];
  const regions =   ['NA', 'EU',  'ME',  'NA', 'EU',  'ME',  'NA', 'EU',  'NA'];
  const countries =  ['US', 'GB',  'AE',  'US', 'GB',  'SA',  'US', 'FR',  'CA'];
  const states =     ['CA', 'ENG', 'DXB', 'NY', 'SCO', 'RIY', 'TX', 'IDF', 'ON'];
  const cities = ['Los Angeles', 'London', 'Dubai City', 'New York City', 'Edinburgh', 'Riyadh City', 'Houston', 'Paris', 'Toronto'];
  const bankNames = ['Chase Bank', 'Bank of America', 'Wells Fargo', 'Citibank', 'US Bank', 'PNC Bank', 'TD Bank', 'Capital One', 'HSBC'];
  const bankAddresses = ['123 Main St, New York, NY 10001', '456 Broadway, Los Angeles, CA 90001', '789 Market St, San Francisco, CA 94105', '321 Park Ave, Chicago, IL 60601', '654 Oak Blvd, Houston, TX 77001', '987 Pine Rd, Philadelphia, PA 19101', '111 Elm St, Boston, MA 02101', '222 Cedar Ln, Miami, FL 33101', '333 Maple Dr, Seattle, WA 98101'];
  return EMPLOYER_NAMES.map((name, i) => ({
    id: i + 1,
    name,
    email: `contact@${name.toLowerCase().replace(/[^a-z]/g, '')}.com`,
    phone: `+1-555-${String(1000 + i * 111).slice(0, 4)}`,
    designation: designations[i % designations.length],
    role: roles[i % roles.length],
    region: regions[i % regions.length],
    country: countries[i % countries.length],
    state: states[i % states.length],
    city: cities[i % cities.length],
    einNumber: `${String(10 + i * 3).slice(0, 2)}-${String(1000000 + i * 123456).slice(0, 7)}`,
    addressLine1: bankAddresses[i % bankAddresses.length].split(',')[0],
    addressLine2: i % 3 === 0 ? `Suite ${100 + i}` : '',
    zipCode: `${10000 + i * 1111}`.slice(0, 5),
    status: i < 4 ? 'ACTIVE' : i < 7 ? 'IN_PAYROLL' : 'INACTIVE',
    createdAt: daysAgo(rand(30, 365)),
    payType: i % 2 === 0 ? 'HOURLY' : 'SALARY',
    payRate: i % 2 === 0 ? 18 + (i % 15) * 2 : 35000 + (i % 10) * 5000,
    payFrequency: ['Weekly', 'Bi-Weekly', 'Monthly'][i % 3],
    hoursThisPeriod: 30 + (i % 50),
    nextPayDate: daysAgo(-(3 + i % 12)),
    salaryPeriodFrom: daysAgo(14 + (i % 7)),
    salaryPeriodTo: daysAgo(-(i % 7)),
    dateOfBirth: new Date(1975 + (i % 15), (i * 3) % 12, 1 + (i * 7) % 28).toISOString(),
    hireDate: daysAgo(365 + i * 90),
    endDate: i >= 7 ? daysAgo(i * 5) : null,
    endDateReason: i >= 7 ? ['Resignation', 'Contract Ended'][i % 2] : null,
    bankName: bankNames[i % bankNames.length],
    bankAddress: bankAddresses[i % bankAddresses.length],
    accountNumber: `****${String(4000 + i * 1111).slice(-4)}`,
    routingNumber: `0${21000000 + i * 11111}`.slice(0, 9),
  }));
}

function generateVendors() {
  const vendorNames = [
    'Airport Services Corp.', 'City Toll Authority', 'MetroParking Ltd.',
    'AirPort Ground Transport', 'TollBridge Inc.', 'ParkSafe Systems',
    'Terminal Logistics Co.', 'Highway Pass Services', 'AeroGate Solutions',
    'CityEntry Tolls LLC', 'FlyPort Services', 'BridgePass Corp.',
  ];
  const vendorTypes = ['SERVICE_PROVIDERS', 'SERVICE_PROVIDERS', 'SERVICE_PROVIDERS', 'SERVICE_PROVIDERS', 'SERVICE_PROVIDERS', 'SERVICE_PROVIDERS', 'SUPPLIERS', 'SUPPLIERS', 'EQUIPMENT', 'SERVICE_PROVIDERS', 'CONSULTANT', 'SUBCONTRACTORS'];
  const feeTypes = ['AIRPORT', 'TOLL', 'PARKING', 'AIRPORT', 'TOLL', 'PARKING', 'AIRPORT', 'TOLL', 'AIRPORT', 'CITY', '', ''];
  const countries = ['US', 'US', 'GB', 'AE', 'CA', 'US', 'SA', 'MX', 'US', 'GB', 'AE', 'US'];
  const vBankNames = ['JPMorgan Chase', 'Bank of America', 'Wells Fargo', 'Citibank', 'US Bank', 'PNC', 'TD Bank', 'Capital One', 'HSBC', 'Goldman Sachs', 'Barclays', 'Deutsche Bank'];
  return vendorNames.map((name, i) => ({
    id: i + 1,
    name,
    contactName: `${['John', 'Sarah', 'Mike', 'Aisha', 'Omar', 'Lisa', 'Carlos', 'Yuki', 'Raj', 'Emma', 'Ali', 'Chen'][i]} ${['Smith', 'Lee', 'Brown', 'Khan', 'Patel', 'Garcia', 'Santos', 'Kim', 'Chen', 'Wilson', 'Al-Said', 'Tanaka'][i]}`,
    email: `ops@${name.toLowerCase().replace(/[^a-z]/g, '').slice(0, 12)}.com`,
    phone: `+1-555-${String(2000 + i * 123).slice(0, 4)}`,
    type: vendorTypes[i],
    feeType: feeTypes[i] || null,
    linkedDriverId: null,
    country: countries[i],
    serviceArea: ['JFK Airport', 'Lincoln Tunnel', 'Heathrow Parking', 'DXB Terminal 3', 'Toronto Airport', 'LAX Arrivals', 'Riyadh Airport', 'Mexico City Toll', 'SFO Ground', 'M25 Toll', 'Dubai Airport', 'Newark Airport'][i],
    status: i < 10 ? 'ACTIVE' : 'INACTIVE',
    contractEnd: daysAgo(-rand(30, 365)),
    createdAt: daysAgo(rand(60, 500)),
    einNumber: `${String(20 + i * 5).slice(0, 2)}-${String(2000000 + i * 234567).slice(0, 7)}`,
    mailingAddress: `${100 + i * 50} ${['Broadway', 'Main St', 'Park Ave', 'Market St', 'Oak Blvd', 'Pine Rd', 'Elm St', 'Cedar Ln', 'Maple Dr', 'Birch Way', 'Ash Ct', 'Walnut Pl'][i]}`,
    mailingAddress2: i % 4 === 0 ? `Floor ${i + 1}` : '',
    mailingCity: ['New York', 'Los Angeles', 'London', 'Dubai', 'Toronto', 'San Francisco', 'Riyadh', 'Mexico City', 'Chicago', 'Manchester', 'Abu Dhabi', 'Newark'][i],
    mailingState: ['NY', 'CA', 'ENG', 'DXB', 'ON', 'CA', 'RIY', 'CMX', 'IL', 'ENG', 'AUH', 'NJ'][i],
    mailingZip: ['10001', '90001', 'SW1A 1AA', '', 'M5V 3L9', '94105', '', '06600', '60601', 'M1 1AD', '', '07102'][i],
    mailingCountry: countries[i],
    bankName: vBankNames[i % vBankNames.length],
    accountNumber: `****${String(5000 + i * 1234).slice(-4)}`,
    routingNumber: `0${22000000 + i * 22222}`.slice(0, 9),
  }));
}

function generateDriverVendors(allDrivers: any[], allTrips: any[], vendorStartId: number) {
  return allDrivers.map((d, i) => {
    const driverTrips = allTrips.filter(t => t.driverId === d.id && t.status === 'COMPLETED');
    const totalPaid = driverTrips.reduce((s, t) => s + (t.baseFare || 0) + (t.tip || 0), 0);
    const totalTips = driverTrips.reduce((s, t) => s + (t.tip || 0), 0);
    const pendingTrips = allTrips.filter(t => t.driverId === d.id && t.status !== 'COMPLETED' && t.status !== 'CANCELLED');
    const pendingAmount = pendingTrips.reduce((s, t) => s + (t.baseFare || 0), 0);
    return {
      id: vendorStartId + i,
      name: `${d.firstName} ${d.lastName}`,
      contactName: `${d.firstName} ${d.lastName}`,
      email: d.email,
      phone: d.phone,
      type: '1099_DRIVER',
      feeType: null,
      linkedDriverId: d.id,
      country: d.countryCode || d.address?.country || 'US',
      serviceArea: d.address?.city || '',
      status: d.status === 'INACTIVE' || d.status === 'SUSPENDED' ? 'INACTIVE' : 'ACTIVE',
      contractEnd: null,
      createdAt: d.createdAt,
      einNumber: d.taxNumber || '',
      mailingAddress: d.address?.street || '',
      mailingAddress2: '',
      mailingCity: d.address?.city || '',
      mailingState: d.address?.state || '',
      mailingZip: d.address?.zip || '',
      mailingCountry: d.countryCode || d.address?.country || 'US',
      bankName: '',
      accountNumber: '',
      routingNumber: '',
      totalPaid: +totalPaid.toFixed(2),
      totalTips: +totalTips.toFixed(2),
      pendingAmount: +pendingAmount.toFixed(2),
      lastPaidDate: driverTrips.length > 0 ? driverTrips[0].createdAt : null,
    };
  });
}

function generateTeamMembers() {
  const TEAM_ROLES = ['ADMIN', 'TECH', 'TECH', 'CUSTOMER_SERVICE', 'CUSTOMER_SERVICE', 'CUSTOMER_SERVICE', 'TECH'];
  const DEPARTMENTS = ['Operations', 'Support', 'Finance', 'Engineering', 'Management'];
  const OFFICES = [
    'Airport Terminal 1', 'Downtown Hub', 'Central Station', 'Mall Entrance',
    'Hospital Main', 'University Gate', 'Convention Center', 'Beach Parking',
    'Hotel District', 'Midtown Office', 'Uptown Branch', 'Harborview',
  ];
  const members = [
    { first: 'Nick', last: 'Thompson' }, { first: 'Sarah', last: 'Chen' },
    { first: 'Omar', last: 'Al-Said' }, { first: 'Jessica', last: 'Rodriguez' },
    { first: 'Dev', last: 'Admin' }, { first: 'Rachel', last: 'Kim' },
    { first: 'Marcus', last: 'Johnson' }, { first: 'Aisha', last: 'Patel' },
    { first: 'Carlos', last: 'Rivera' }, { first: 'Emily', last: 'Wang' },
    { first: 'James', last: 'O\'Brien' }, { first: 'Fatima', last: 'Hassan' },
  ];
  return members.map((m, i) => ({
    id: i + 1,
    firstName: m.first,
    lastName: m.last,
    name: `${m.first} ${m.last}`,
    email: genEmail(m.first, m.last),
    phone: genPhone(),
    role: TEAM_ROLES[i % TEAM_ROLES.length],
    department: DEPARTMENTS[i % DEPARTMENTS.length],
    location: OFFICES[i % OFFICES.length],
    status: i < 10 ? 'ACTIVE' : 'INACTIVE',
    lastLogin: daysAgo(rand(0, 14)),
    createdAt: daysAgo(rand(30, 365)),
  }));
}

const users = generateUsers(47);
const drivers = generateDrivers(38);
const pendingDrivers = generatePendingDrivers(8);
const trips = generateTripsPerDriver(users, drivers);
const payments = generatePaymentsFromTrips(trips);
const bookings = generateBookings(42, users, drivers, trips);
const serviceRequests = generateServiceRequests(25);
const ratings = generateRatings(80, users, drivers, trips);
const reviews = generateReviews(45, users, drivers, trips);
const documents = generateDocuments(30, drivers);
const driverPayments = generateDriverPaymentsFromTrips(trips, drivers);

// Sync driver stats from actual trip data
drivers.forEach((d: any) => {
  const dTrips = trips.filter(t => t.driverId === d.id);
  d.totalTrips = dTrips.length;
  d.earnings = +(dTrips.reduce((s: number, t: any) => s + (t.total || t.fare || 0), 0)).toFixed(2);
});

// Sync user stats from actual trip data
users.forEach((u: any) => {
  const uTrips = trips.filter(t => t.passengerId === u.id);
  u.totalTrips = uTrips.length;
  const fares = uTrips.reduce((s: number, t: any) => s + (t.fare || 0), 0);
  const tips = uTrips.reduce((s: number, t: any) => s + (t.tip || 0), 0);
  u.totalPaid = +(fares + tips).toFixed(2);
  u.totalTips = +tips.toFixed(2);
});

const categories = generateCategories();
const geoStates = generateGeoStates();
const geoCities = generateGeoCities(geoStates);
const locations = generateLocations(geoCities);
const promos = generatePromos();
const employers = generateEmployers();
const baseVendors = generateVendors();
const driverVendors = generateDriverVendors(drivers, trips, baseVendors.length + 1);
const vendors = [...baseVendors, ...driverVendors];
const teamMembers = generateTeamMembers();

// Requests — requesterId references actual users, requesterName matches
const requestTypes = ['MOVING', 'DELIVERY', 'SPECIAL'];
const requestStatuses = ['OPEN', 'IN_PROGRESS', 'RESOLVED', 'CLOSED'];
const priorities = ['HIGH', 'MEDIUM', 'LOW'];
const requests = Array.from({ length: 30 }, (_, i) => {
  const requester = pick(users);
  const assignee = pick(teamMembers);
  return {
    id: i + 1,
    requesterId: requester.id,
    requesterName: `${requester.firstName} ${requester.lastName}`,
    requestType: pick(requestTypes),
    description: `Request for ${pick(requestTypes).toLowerCase()} service at ${pick(STREETS)}, ${pick(CITIES)}`,
    priority: pick(priorities),
    assignedTo: `${assignee.firstName} ${assignee.lastName}`,
    status: pick(requestStatuses),
    country: requester.address?.country || genCountry(),
    createdAt: daysAgo(rand(0, 60)),
  };
});

// Activity log — targetId references actual entity IDs
const actionTypes = ['CREATE', 'UPDATE', 'DELETE', 'LOGIN', 'EXPORT'];
const activityDepartments = ['Operations', 'Support', 'Engineering', 'Finance'];
const targetPools: Record<string, number[]> = {
  User: users.map(u => u.id),
  Driver: drivers.map(d => d.id),
  Trip: trips.slice(0, 50).map(t => t.id),
  Payment: payments.slice(0, 50).map(p => p.id),
  Promo: promos.slice(0, 20).map(p => p.id),
};
const targetTypeKeys = Object.keys(targetPools);
const activitySteps = Array.from({ length: 50 }, (_, i) => {
  const performer = pick(teamMembers);
  const targetType = pick(targetTypeKeys);
  const pool = targetPools[targetType];
  return {
    id: i + 1,
    action: pick(actionTypes),
    performedBy: `${performer.firstName} ${performer.lastName}`,
    department: pick(activityDepartments),
    targetType,
    targetId: pick(pool),
    description: `${pick(actionTypes)} action on ${targetType.toLowerCase()} record`,
    ipAddress: `${rand(10, 255)}.${rand(0, 255)}.${rand(0, 255)}.${rand(1, 254)}`,
    country: genCountry(),
    createdAt: daysAgo(rand(0, 30)),
  };
});

// Notifications — recipientName references actual users/drivers
const NOTIF_CHANNELS = ['PUSH', 'EMAIL', 'SMS', 'IN_APP'];
const NOTIF_STATUSES = ['DELIVERED', 'DELIVERED', 'DELIVERED', 'FAILED', 'PENDING'];
const NOTIF_TITLES = ['Ride Completed', 'Payment Received', 'New Promo Available', 'Document Expiring', 'Driver Approved', 'System Maintenance', 'Subscription Renewed', 'Trip Cancelled'];
const allPeople = [...users.map(u => `${u.firstName} ${u.lastName}`), ...drivers.map(d => d.name)];
const notificationHistory = Array.from({ length: 60 }, (_, i) => ({
  id: i + 1,
  title: pick(NOTIF_TITLES),
  body: `Notification body for ${pick(NOTIF_TITLES).toLowerCase()} event.`,
  recipientName: pick(allPeople),
  channel: pick(NOTIF_CHANNELS),
  status: pick(NOTIF_STATUSES),
  country: genCountry(),
  sentAt: daysAgo(rand(0, 60)),
}));

// Fee History — deterministic per driver, seeded into Supabase
const FH_TYPES = ['DAILY', 'WEEKLY', 'MONTHLY', 'COMMISSION'];
const FH_STATUSES = ['PAID', 'PAID', 'PAID', 'PENDING'];
let fhId = 1;
const feeHistory: any[] = [];
for (const driver of drivers) {
  const count = 3 + (driver.id % 10);
  for (let j = 0; j < count; j++) {
    feeHistory.push({
      id: fhId++,
      driverId: driver.id,
      driverName: driver.name,
      feeType: FH_TYPES[(driver.id + j) % FH_TYPES.length],
      amount: +(500 + ((driver.id * 7 + j * 3) % 95) * 100) / 100,
      date: daysAgo((driver.id * 3 + j * 17) % 180),
      status: FH_STATUSES[(driver.id + j) % FH_STATUSES.length],
    });
  }
}

// Payment Methods per country — seeded into Supabase
const paymentMethodsRegional: any[] = [];
let pmId = 1;
const PM_DATA: Record<string, { code: string; name: string; icon: string; type: string; currency: string }[]> = {
  US: [
    { code: 'STRIPE', name: 'Credit/Debit Card', icon: 'pi pi-credit-card', type: 'card', currency: 'USD' },
    { code: 'APPLE_PAY', name: 'Apple Pay', icon: 'pi pi-apple', type: 'wallet', currency: 'USD' },
    { code: 'GOOGLE_PAY', name: 'Google Pay', icon: 'pi pi-google', type: 'wallet', currency: 'USD' },
    { code: 'VENMO', name: 'Venmo', icon: 'pi pi-money-bill', type: 'wallet', currency: 'USD' },
    { code: 'PAYPAL', name: 'PayPal', icon: 'pi pi-paypal', type: 'wallet', currency: 'USD' },
    { code: 'ZELLE', name: 'Zelle', icon: 'pi pi-bolt', type: 'bank', currency: 'USD' },
    { code: 'CASH_APP', name: 'Cash App', icon: 'pi pi-dollar', type: 'wallet', currency: 'USD' },
    { code: 'CASH', name: 'Cash', icon: 'pi pi-wallet', type: 'cash', currency: 'USD' },
  ],
  CA: [
    { code: 'STRIPE', name: 'Credit/Debit Card', icon: 'pi pi-credit-card', type: 'card', currency: 'CAD' },
    { code: 'APPLE_PAY', name: 'Apple Pay', icon: 'pi pi-apple', type: 'wallet', currency: 'CAD' },
    { code: 'INTERAC', name: 'Interac e-Transfer', icon: 'pi pi-send', type: 'bank', currency: 'CAD' },
    { code: 'CASH', name: 'Cash', icon: 'pi pi-wallet', type: 'cash', currency: 'CAD' },
  ],
  GB: [
    { code: 'STRIPE', name: 'Credit/Debit Card', icon: 'pi pi-credit-card', type: 'card', currency: 'GBP' },
    { code: 'APPLE_PAY', name: 'Apple Pay', icon: 'pi pi-apple', type: 'wallet', currency: 'GBP' },
    { code: 'REVOLUT', name: 'Revolut', icon: 'pi pi-sync', type: 'wallet', currency: 'GBP' },
    { code: 'CASH', name: 'Cash', icon: 'pi pi-wallet', type: 'cash', currency: 'GBP' },
  ],
  AE: [
    { code: 'STRIPE', name: 'Credit/Debit Card', icon: 'pi pi-credit-card', type: 'card', currency: 'AED' },
    { code: 'APPLE_PAY', name: 'Apple Pay', icon: 'pi pi-apple', type: 'wallet', currency: 'AED' },
    { code: 'CASH', name: 'Cash', icon: 'pi pi-wallet', type: 'cash', currency: 'AED' },
  ],
};
for (const [cc, methods] of Object.entries(PM_DATA)) {
  for (const m of methods) {
    paymentMethodsRegional.push({ id: pmId++, countryCode: cc, ...m });
  }
}

// Dashboard city stats — seeded from mock-stats-cache into Supabase
// (imported at migration time; geo-data based stats live in dashboard_city_stats table)

// Stats Revenue — monthly revenue breakdown from actual payments
const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const revenueByMonth: Record<string, number> = {};
for (const p of payments) {
  if (p.status !== 'PAID') continue;
  const d = new Date(p.createdAt);
  const key = `${d.getFullYear()}-${String(d.getMonth()).padStart(2, '0')}`;
  revenueByMonth[key] = (revenueByMonth[key] || 0) + (p.amount || 0);
}
const statsRevenue = Object.entries(revenueByMonth)
  .sort(([a], [b]) => a.localeCompare(b))
  .map(([key, rev], i) => {
    const [year, monthIdx] = key.split('-');
    return { id: i + 1, month: MONTH_NAMES[+monthIdx], year: +year, revenue: +rev.toFixed(2) };
  });

const leaveTypes = ['PTO', 'SICK', 'PERSONAL', 'FLOATING_HOLIDAY', 'UNPAID'];
const leaveStatuses = ['PENDING', 'APPROVED', 'APPROVED', 'APPROVED', 'REJECTED'];
const leaveRequests = employers.flatMap((emp: any, ei: number) => {
  const count = 1 + (ei % 3);
  return Array.from({ length: count }, (_, li) => {
    const start = new Date(Date.now() - (ei * 15 + li * 30) * 86400000);
    const days = 1 + (li % 5);
    const end = new Date(start.getTime() + days * 86400000);
    return {
      id: ei * 10 + li + 1,
      employeeId: emp.id,
      employeeName: emp.name,
      leaveType: leaveTypes[(ei + li) % leaveTypes.length],
      startDate: start.toISOString(),
      endDate: end.toISOString(),
      totalDays: days,
      reason: ['Family event', 'Medical appointment', 'Vacation', 'Personal day', 'Moving'][
        (ei + li) % 5
      ],
      status: leaveStatuses[(ei + li) % leaveStatuses.length],
      approvedBy: leaveStatuses[(ei + li) % leaveStatuses.length] !== 'PENDING' ? 'Admin' : null,
      approvedAt: leaveStatuses[(ei + li) % leaveStatuses.length] !== 'PENDING'
        ? new Date(start.getTime() - 2 * 86400000).toISOString()
        : null,
      createdAt: new Date(start.getTime() - 7 * 86400000).toISOString(),
    };
  });
});

export const MOCK_DB: Record<string, any[]> = {
  '/passengers': users,
  '/drivers': drivers,
  '/drivers/pending': pendingDrivers,
  '/trips': trips,
  '/trips/airport': trips.filter((t: any) => t.airport != null),
  '/payments': payments,
  '/payments/driver': driverPayments,
  '/bookings': bookings,
  '/service-requests': serviceRequests,
  '/ratings': ratings,
  '/reviews': reviews,
  '/documents': documents,
  '/categories': categories,
  '/locations': locations,
  '/geo/countries': generateGeoCountries(),
  '/geo/states': geoStates,
  '/geo/cities': geoCities,
  '/promos': promos,
  '/employees': employers,
  '/vendors': vendors,
  '/team': teamMembers,
  '/requests': requests,
  '/activity/steps': activitySteps,
  '/notifications/history': notificationHistory,
  '/tiers': [
    { id: 1, name: 'Economy' },
    { id: 2, name: 'Premium' },
    { id: 3, name: 'More' },
    { id: 4, name: 'Accessibility' },
  ],
  '/fee-history': feeHistory,
  '/payment-methods': paymentMethodsRegional,
  '/stats/revenue': statsRevenue,
  '/leave-requests': leaveRequests,
};

export function generateFeeHistory(driverId: number): any[] {
  return feeHistory.filter(fh => fh.driverId === driverId);
}
